var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDark())?_c('vue-element-loading',{attrs:{"active":_vm.active,"color":"#fff","background-color":"rgba(34, 34, 34, 0.9)"}}):_c('vue-element-loading',{attrs:{"active":_vm.active}})}
var staticRenderFns = []

export { render, staticRenderFns }